"use strict";

var _interopRequireDefault = require("/code/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.number.constructor");
require("core-js/modules/es6.number.is-integer");
var _permission = _interopRequireDefault(require("@/utils/permission"));
var _product_treatmentpartquantity = require("@/api/product_treatmentpartquantity");
var _utils = require("@/utils");
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// secondary package based on el-pagination

var defaultTreatmentPartQuantity = {
  quantity: '',
  description: ''
};
var checkNumber = function checkNumber(rule, value, callBack) {
  if (!Number.isInteger(value)) {
    callBack(new Error('请输入合法的整数值'));
  } else {
    if (value < 0) {
      callBack(new Error('数值范围不在0-1000000'));
    } else if (value > 1000000) {
      callBack(new Error('数值范围不在0-1000000'));
    } else {
      callBack();
    }
  }
};
var _default = exports.default = {
  components: {
    Pagination: _Pagination.default
  },
  data: function data() {
    return {
      listQuery: {
        page: 1,
        page_size: 10
      },
      listLoading: true,
      tableData: [],
      treatmentpartquantity: defaultTreatmentPartQuantity,
      dialogVisible: false,
      dialogType: 'new',
      number: '',
      rule1: {
        quantity: [{
          required: true,
          message: '请输入穴位数数量',
          trigger: 'blur'
        }, {
          validator: checkNumber
        }]
      },
      sum_quantity: ''
    };
  },
  created: function created() {
    this.getList();
  },
  methods: {
    checkPermission: _permission.default,
    handleAdd: function handleAdd() {
      this.treatmentpartquantity = Object.assign({}, defaultTreatmentPartQuantity);
      this.dialogType = 'new';
      this.dialogVisible = true;
    },
    getList: function getList() {
      var _this = this;
      this.listLoading = true;
      (0, _product_treatmentpartquantity.getTreatmentPartQuantityAll)(this.listQuery).then(function (response) {
        _this.tableData = response.data;
        _this.sum_quantity = _this.tableData.results[0].sum_quantity;
      });
      this.listLoading = false;
    },
    confirm: function () {
      var _confirm = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(form) {
        var _this2 = this;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.$refs[form].validate(function (valid) {
                if (valid) {
                  var isEdit = _this2.dialogType === 'edit';
                  if (isEdit) {
                    // updateTreatmentPartSaleQuantity(this.treatmentpartsalequantity.id, this.treatmentpartsalequantity).then(res => {
                    //   this.getList()
                    //   this.dialogVisible = false
                    //   this.$message({
                    //     message: '编辑成功',
                    //     type: 'success'
                    //   })
                    // })
                  } else {
                    (0, _product_treatmentpartquantity.createTreatmentPartQuantity)(_this2.treatmentpartquantity).then(function (res) {
                      _this2.getList();
                      _this2.dialogVisible = false;
                      _this2.$message({
                        message: '新增成功',
                        type: 'success'
                      });
                    });
                  }
                } else {
                  return false;
                }
              });
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function confirm(_x) {
        return _confirm.apply(this, arguments);
      }
      return confirm;
    }()
  }
};